import {
  Input,
  Form,
  Radio,
} from "antd";
import {
  createElement,
  Component,
  Fragment,
  Props as ReactProps,
} from "react";
import Order from "../../../../entity/order";
import { FormComponentProps } from "antd/lib/form";
import Store from "../../../../entity/store";
import Card from "../../../../entity/card";

const RadioGroup = Radio.Group;

type Props = ReactProps<HTMLSpanElement> & {
  order: Order;
  store: Store;
  updateOrderField: (order: Partial<Order>) => void;
  getFieldDecorator: any;
};
type State = {};

class PaymentCard extends Component<Props, State> {
  constructor(props: Props & FormComponentProps) {
    super(props);

    this.state = {};
  }

  public render() {
    const { order, store, updateOrderField, getFieldDecorator } = this.props;

    if (!store.enableCartCredit) {
      return null;
    }

    const styleFormItem = {
      style: {
        marginBottom: 14,
      },
    };

    const updateCard = (partial: Partial<Card>) => {
      const currentCard = order.card;

      const card = new Card({ ...currentCard, ...partial });
      updateOrderField({ card });
    };

    if (order.payment === 'before-credit') {
      return <Fragment>
        <Form.Item {...styleFormItem} label="お支払い方法">
          <RadioGroup onChange={(e) => updateOrderField({ payment: e.target.value })} value={order.payment}>
            <Radio value="cash">現金</Radio>
            <Radio value="before-credit">クレジット</Radio>
          </RadioGroup>
        </Form.Item>
        <Form.Item　{...styleFormItem} label="クレジット番号">
          {getFieldDecorator('cardInputNumber', {
            rules: [
              {
                required: order.payment === 'before-credit',
                message: 'カード番号は必須項目です。',
              },
            ],
            initialValue: order.card && order.card.inputNumber || '',
          })(
            <Input
              onChange={(e) => updateCard({ inputNumber: e.target.value })}
              placeholder="0000 1111 2222 3333"
            />
          )}
        </Form.Item>
        <Form.Item　{...styleFormItem} label="有効期限">
          {getFieldDecorator('cardInputExpMonth', {
            rules: [
              {
                required: order.payment === 'before-credit',
                message: '有効期限は必須項目です。',
              },
            ],
            initialValue: order.card && order.card.inputExpMonth || '',
          })(
            <Input
              onChange={(e) => updateCard({ inputExpMonth: e.target.value && parseInt(e.target.value) || null })}
              placeholder="MM"
              style={{ width: 60, display: 'inline-block' }}
            />
          )}
          &nbsp; / &nbsp;
          {getFieldDecorator('cardInputExpYear', {
            rules: [
              {
                required: order.payment === 'before-credit',
                message: '有効期限は必須項目です。',
              },
            ],
            initialValue: order.card && order.card.inputExpYear || '',
          })(
            <Input
              onChange={(e) => updateCard({ inputExpYear:  e.target.value && parseInt(e.target.value) || null })}
              placeholder="YY"
              style={{ width: 60, display: 'inline-block' }}
            />
          )}
        </Form.Item>
        <Form.Item　{...styleFormItem} label="セキュリティ番号">
          {getFieldDecorator('cardInputCvc', {
            rules: [
              {
                required: order.payment === 'before-credit',
                message: 'セキュリティ番号は必須項目です。',
              },
            ],
            initialValue: order.card && order.card.inputCvc || '',
          })(
            <Input
              onChange={(e) => updateCard({ inputCvc: e.target.value })}
              placeholder="000"
              style={{ width: 70 }}
            />
          )}
        </Form.Item>
      </Fragment>
    } else {
      return <Form.Item {...styleFormItem} label="お支払い方法">
        <RadioGroup onChange={(e) => updateOrderField({ payment: e.target.value })} value={order.payment}>
          <Radio value="cash">現金</Radio>
          <Radio value="before-credit">クレジット</Radio>
        </RadioGroup>
      </Form.Item>;
    }
  }
}

export default PaymentCard;
